import React from "react";
import T from "prop-types";
import { COMPANY } from "APP_ROOT/constants";
import {
  Close,
  Header,
  Modal
} from "../../../../../../shared/components/Modal";
import Form from "./Form";

export default function RequiredComponentModal({
  open,
  close,
  lineItem,
  repairOrder
}) {
  return (
    <Modal open={open} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Create Required Component</h4>
      </Header>
      <Form
        close={close}
        company={repairOrder.get(COMPANY).toJS()}
        enableReinitialize
        lineItem={lineItem}
        initialValues={{
          ...lineItem,
          create_incoming_quote: true
        }}
      />
    </Modal>
  );
}

RequiredComponentModal.propTypes = {
  close: T.func,
  open: T.func,
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/RequiredComponentModal.jsx